import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-three-columns-two-page',
  templateUrl: './courses-grid-style-three-columns-two-page.component.html',
  styleUrls: ['./courses-grid-style-three-columns-two-page.component.scss']
})
export class CoursesGridStyleThreeColumnsTwoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
